// src/app/core/auth/auth.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.token();

  // Only attach Bearer header for requests to own API base URL.
  // Require a path separator after the prefix so that /api-docs or /api-health
  // do not accidentally receive Bearer tokens.
  const apiPrefix = environment.apiUrl.endsWith('/')
    ? environment.apiUrl
    : environment.apiUrl + '/';
  if (token && (req.url.startsWith(apiPrefix) || req.url === environment.apiUrl)) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLogoutEndpoint = req.url.includes('/api/access/logout');
      if (!isLogoutEndpoint && error.status === 401 && error.error?.data?.sessionExpired === true) {
        authService.logout(); // clear state synchronously before issuing logout API call
        authService.logoutAsync().subscribe(); // fire-and-forget to server
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
